import {cn} from "../../../lib/utils";
import {Dialog, DialogContent} from "../../../components/ui/dialog";
import React, {KeyboardEventHandler, useEffect} from "react";
import {
    Carousel,
    CarouselApi,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious
} from "../../../components/ui/carousel";
import {Media} from "../../../data/model/shared";

interface Props {
    media: Media | undefined;
    className?: string;
}

export function MediaCarousel({ media, ...props }: Props) {
    const [shadowboxState, setShadowboxState] = React.useState<{ open: boolean, startIndex?: number }>({ open: false });

    if (!media || media.items.length === 0) {
        return null;
    }

    return <div  {...props} className={cn("flex flex-row gap-3 items-start overflow-x-scroll pb-4", props.className)}>
        <Shadowbox startIndex={shadowboxState.startIndex} media={media.items} open={shadowboxState.open} onOpenChange={(open) => setShadowboxState({ open })} />
        {media.items.map((item, index) => (
            <img
                key={index}
                src={item}
                alt={`Project Media ${index + 1}`}
                className={cn("w-24 rounded-md shadow-md border cursor-pointer transition-all duration-300 hover:scale-[99%] active:scale-95", media.display === "landscape" && "w-56")}
                onClick={() => setShadowboxState({ open: true, startIndex: index })}
            />
        ))}
    </div>
}

export function Shadowbox (props: { media: string[], open?: boolean, onOpenChange?: (open: boolean) => unknown, startIndex?: number }) {
    const close = () => props.onOpenChange?.(false);

    return <Dialog open={props.open} onOpenChange={props.onOpenChange}>
        <DialogContent onClick={close} className={"bg-transparent border-0 max-w-screen w-screen max-h-screen h-screen flex flex-col items-center"}>
            <ShadowboxCarousel startIndex={props.startIndex} media={props.media} onClickOutside={close} />
        </DialogContent>
    </Dialog>
}

function ShadowboxCarousel (props: { media: string[], onClickOutside: () => void, startIndex?: number }) {
    const [carouselApi, setCarouselApi] = React.useState<CarouselApi>()
    useEffect(() => {
        const listener = function(event: KeyboardEvent) {
            if (event.defaultPrevented || !carouselApi) {
                return;
            }

            switch(event.code) {
                case "ArrowLeft":
                    carouselApi.scrollPrev();
                    break;
                case "ArrowRight":
                    carouselApi.scrollNext();
                    break;
            }

            event.preventDefault();
        };
        window.addEventListener("keydown", listener, true);
        return () => window.removeEventListener("keydown", listener, true);
    })
    return <Carousel
        setApi={setCarouselApi}
        opts={{ startIndex: props.startIndex }}
        onClick={(e) => e.stopPropagation()}
        className={"w-[80svw] h-full"}
    >
        <CarouselContent>
            {props.media.map((item) => (
                <CarouselItem key={item}>
                    <div onClick={props.onClickOutside} className="p-1 h-[90svh] flex flex-col items-center justify-center">
                        <img onClick={(e) => e.stopPropagation()} className={"rounded-md max-h-[90svh]"} src={item} />
                    </div>
                </CarouselItem>
            ))}
        </CarouselContent>
        <CarouselPrevious />
        <CarouselNext />
    </Carousel>
}